import { EntityAdapter, createEntityAdapter, EntityState } from "@ngrx/entity";
import { PaginationMetaData } from "../../../api/models/pagination-meta-data.model";

import { UserListItem } from "../../../api/models/user.model";

export const usersAdapter: EntityAdapter<UserListItem> =
    createEntityAdapter<UserListItem>({
        selectId: (user: UserListItem) => user.Id,
    });

export interface UserState extends EntityState<UserListItem> {
    ids: number[];
    entities: any;
    total: number;
    loaded: boolean;

    paginationMetaData: PaginationMetaData;
    searchString: string;
    error:any;
}
